//= Functions & Modules
// Others
import React from 'react';

type Variant = 'primary' | 'secondary' | 'danger' | 'ghost';

type Props = React.HTMLProps<HTMLButtonElement> & {
    size?: string;
    variant?: Variant;
};

const variantClasses: Record<Variant, string> = {
    primary: 'bg-accent hover:bg-accent-hover text-white',
    secondary: 'bg-white/[0.08] hover:bg-white/[0.12] text-title',
    danger: 'bg-danger hover:bg-danger-hover text-white',
    ghost: 'bg-transparent hover:bg-white/[0.06] text-unselected2 hover:text-title',
};

export class Button extends React.PureComponent<Props> {
    static defaultProps = {
        size: 'regular',
        variant: 'primary' as Variant,
    };

    render() {
        const { size, variant, className, type, ...rest } = this.props;
        const variantStyle = variantClasses[variant as Variant] ?? variantClasses.primary;
        return (
            <button
                type={(type as any) ?? 'button'}
                {...rest}
                className={`${variantStyle} font-medium py-2 px-4 rounded-lg cursor-pointer transition-colors text-sm ${className || ''}`}
            >
                {this.props.children}
            </button>
        );
    }
}
